module.exports = __webpack_public_path__ + "img/1482558483.7a2cdf26.jpg";